import { ImportType } from "./enums";
import { ImportStatus } from "./enums";

export const ImportTypeName = {
  [ImportType.ProductsDetail]: "Importar plantilla de ”Detalle de Productos”",
  [ImportType.Phones]: "Importar plantilla de ”Teléfonos”",
  [ImportType.Addresses]: "Importar plantilla de ”Direcciones”",
  [ImportType.Emails]: "Importar plantilla de ”Correos”",
  [ImportType.Contacts]: "Importar plantilla de ”Referidos”",
  [ImportType.Payments]: "Importar plantilla de ”Pagos”",
  [ImportType.ExternalTypifications]: "Importar plantilla de ”Tipificaciones externas”",

  [ImportType.AgentsAssignment]: "Importar plantilla de ”Asignacion de Usuarios”",
  [ImportType.ActivateAccounts]: "Activar / Inactivar ”Productos”",
  [ImportType.InactivateAccounts]: "Activar / Inactivar ”Productos”",
  [ImportType.ActiveClients]: "Activar / Inactivar ”Contactos”",
  [ImportType.InactiveClients]: "Activar / Inactivar ”Contactos”",
  [ImportType.ActivatePhones]: "Activar / Inactivar ”Teléfonos”",
  [ImportType.InactivatePhones]: "Activar / Inactivar ”Teléfonos”",
  [ImportType.ContactsSequence]: "Asignar contactos a secuencias",
};

export const ImportStatusName = {
  [ImportStatus.Waiting]: "En espera",
  [ImportStatus.Success]: "Exitoso",
  [ImportStatus.Error]: "Error",
};

export const importsTableColumns = (showBases) => {
  const columns = [
    {
      slots: { title: "titleEntity", customRender: "entity" },
      key: "entity",
      dataIndex: "entity.name",
      width: 180,
      fixed: "left",
    },
    {
      title: "Campañas",
      dataIndex: ["portfolio", "name"],
      key: "portfolio.name",
      width: 200,
      fixed: "left",
    },
    {
      title: "Tipo",
      dataIndex: "type_import_name",
      key: "type_import",
      width: 120,
      fixed: "left",
      slots: { customRender: "type_import" },
    },
    {
      title: "Tipo de asignación",
      dataIndex: "type_assignment_name",
      key: "type_asign",
      width: 160,
    },
    {
      title: "Progreso",
      dataIndex: "status_name",
      key: "progress",
      width: 100,
      slots: { customRender: "progress" },
    },
    {
      title: "Estado",
      dataIndex: "status_name",
      key: "status_name",
      width: 80,
      slots: { customRender: "status" },
    },
    {
      title: "Información",
      dataIndex: "error_log",
      key: "error_log",
      width: 140,
      slots: { customRender: "info" },
    },
    {
      title: "Hora inicial",
      dataIndex: "hour_start",
      key: "hour_start",
      width: 110,
    },
    {
      title: "Hora final",
      dataIndex: "hour_end",
      key: "hour_end",
      width: 110,
    },
    {
      title: "Reg. nuevos",
      dataIndex: "total_imported",
      key: "total_imported",
      width: 120,
    },
    {
      title: "Reg. actualizados",
      dataIndex: "updated_records",
      key: "updated_records",
      width: 160,
    },
    {
      title: "Reg. no importados",
      dataIndex: "total_fail_imported",
      key: "total_fail_imported",
      width: 160,
    },
    {
      title: "Importado por",
      key: "imported_by",
      dataIndex: "imported_by",
      width: 220,
    },
  ];

  if (showBases) {
    columns.splice(2, 0, {
      slots: { title: "titleBases", customRender: "base" },
      dataIndex: "base.name",
      key: "bases",
      width: 260,
      fixed: "left",
    });
  }

  return columns;
};
